<template>
    <div>
        <generic title="Serviço Indisponível" description="Nossos servidores estão temporariamente indisponíveis. Por favor, tente novamente mais tarde."></generic>
    </div>
</template>

<style scoped>

</style>

<script>
import Generic from "@/views/Errors/Generic.vue";

export default {
    components: {Generic}
}
</script>